import service from './../utils/server'

const modName = '/common/web/select/';

/**
 * 市场
 */
export const market = data => {
    return service({
        url: modName + 'market',
        method: 'post',
        data
    })
};


/**
 * 地接社
 */
export const marketTravelAgency = data => {
    return service({
        url: modName + 'marketTravelAgency',
        method: 'post',
        data
    })
};

/**
 * 行程状态
 */
export const selectTravelStatus = data => {
  return service({
    url: modName + 'selectTravelStatus',
    method: 'post',
    data
  })
};

/**
 * 根据市场id查询地接社
 * @param data
 * @returns {*}
 */
export const getExpensesAreasOptionInfo = data => {
  return service({
    url: modName + 'marketTravelAgency/'+ data.marketId,
    method: 'post'
  })
};

/**
 * 业务员
 * @param data
 * @returns {*}
 */
export const orderUserNo = data => {
  return service({
    url: modName + 'orderUserNo',
    method: 'post',
    data
  })
};






// WEBPACK FOOTER //
// ./src/api/selects.js